import { authHeader, handleResponse } from "./helper";
import { getCookie } from './cookies';
import config from "../config";

const ENDPOINT_MOCKY = 'https://run.mocky.io/v3';

export const heuristicMatch = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };
  const url = new URL(`${config.apiReservationUrl}/reservations/heuristicMatch`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getReservation = async (params, branch_office_id) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };
  const url = new URL(
    `${config.apiReservationUrl}/reservations/${params.reservation_id}`
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getReservations = async (params, branch_office_id) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };
  const url = new URL(`${config.apiReservationUrl}/reservations`);

  Object.keys(params).forEach((key) => {
    if (params[key] !== undefined && params[key] !== 'undefined') {
      url.searchParams.append(key, params[key])
    }
  });

  return await fetch(url, requestOptions).then(handleResponse);
};

export const getReservationsBySearch = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };
  const url = new URL(`${config.apiReservationUrl}/reservations/reservationsBySearch`);

  Object.keys(params).forEach((key) => {
    if (params[key] !== undefined && params[key] !== 'undefined') {
      url.searchParams.append(key, params[key])
    }
  });

  return await fetch(url, requestOptions).then(handleResponse);
};

export const summarizedPatientsByReservation = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const url = new URL(`${config.apiReservationUrl}/reservations/${params.id}/summarizedPatients`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getBlocks = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const url = new URL(`${config.apiReservationUrl}/reservations/blocks`);

  Object.keys(params).forEach((key) => {
    if (params[key] !== undefined && params[key] !== 'undefined') {
      url.searchParams.append(key, params[key])
    }
  })
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getReservationServices = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(
    `${config.apiReservationUrl}/reservations/${params.id}/prestations`
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getConfirmedPrestationsSummary = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const url = new URL(
    `${config.apiReservationUrl}/reservations/confirmedPrestationsSummary`
  );
  Object.keys(params).forEach((key) =>
    url.searchParams.append(key, params[key])
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

export const deleteReservation = async (params) => {
  const requestOptions = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const url = new URL(
    `${config.apiReservationUrl}/reservations/${params.reservation_id}`
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getPatients = async (params, branch_office_id) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };
  const url = new URL(
    `${config.apiReservationUrl}/reservations/${params.reservation_id}/patients`
  );

  return await fetch(url, requestOptions).then(handleResponse);
};

export const getCanceledPatients = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };
  const url = new URL(
    `${config.apiReservationUrl}/reservations/${params.reservation_id}/canceledPatients`
  );

  return await fetch(url, requestOptions).then(handleResponse);
};

export const getServicesSummary = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const url = new URL(
    `${config.apiReservationUrl}/reservations/${params.reservation_id}/prestationsDetails`
  );
  Object.keys(params).forEach((key) =>
    url.searchParams.append(key, params[key])
  );
  return await fetch(url, requestOptions).then(handleResponse);
};

export const saveReservation = async (params) => {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };
  const url = new URL(`${config.apiReservationUrl}/reservations/update`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const createReservation = async (params, branch_office_id) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };
  const url = new URL(`${config.apiReservationUrl}/reservations/create`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const createApplicantByReservation = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiReservationUrl}/applicants`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const createCompanyByReservation = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiReservationUrl}/companies`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const createCostCenterByReservation = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiReservationUrl}/costCenters`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const reservationToDraft = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiReservationUrl}/reservations/toDraft`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const reservationToConfirm = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiReservationUrl}/reservations/confirm`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const overcapacityCheck = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(
    `${config.apiReservationUrl}/reservations/overcapacityCheck`
  );

  return await fetch(url, requestOptions).then(handleResponse);
};

export const getPatientReevaluations = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };

  const url = new URL(`${config.apiClinicalUrl}/revaluation/getReevaluationPatients`);

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

export const getDetailedReevaluationPatients = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };

  const url = new URL(`${config.apiClinicalUrl}/revaluation/getDetailedReevaluationPatients`);

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

export const getReevaluationData = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(`${config.apiClinicalUrl}/revaluation/reevaluationDetails`);

  Object.keys(params).forEach((key) =>
    url.searchParams.append(key, params[key])
  );

  return await fetch(url, requestOptions).then(handleResponse);
};

export const createReevaluation = async (params, branch_office_id) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      country_code: getCookie('country_code'),
    },
    body: JSON.stringify(params)
  };

  const url = new URL(`${config.apiClinicalUrl}/revaluation/create`);

  return await fetch(url, requestOptions).then(handleResponse);
};

export const saveReevaluation = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify(params)
  };

  const url = new URL(`${ENDPOINT_MOCKY}/63aaabf4-137f-485d-870d-e51bdb0ed130`);

  return await fetch(url, requestOptions).then(handleResponse);
};

export const checkIfReevaluationFinish = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const url = new URL(
    `${config.apiClinicalUrl}/revaluation/checkIfFinished/${params.medicalConsultationId}`
  );

  return await fetch(url, requestOptions).then(handleResponse);
};

export const updatePayment = async params => {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const url = new URL(
    `${config.apiReservationUrl}/reservations/updatePayment`
  );

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

export const getForecastPredictions = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const url = new URL(
    `${config.apiForecastUrl}/predictor`
  );

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
}

export const getForecastPredictionsByIds = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const url = new URL(
    `${config.apiForecastUrl}/predictor/byIds`
  );

  const queryParams = new URLSearchParams(params);
  url.search = queryParams.toString();

  return await fetch(url, requestOptions).then(handleResponse);
}

export const saveForecastPrediction = async (params) => {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiForecastUrl}/predictor/?`);

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

export const getAllBlocks = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiGeneralUrl}/blocks/`);

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }
  return await fetch(url, requestOptions).then(handleResponse);
};

export const evaluateDocument = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiClinicalUrl}/revaluation/evaluatePrescriptionDocument`);

  return await fetch(url, requestOptions).then(handleResponse);
};

export const getDocumentRejectionReasons = async () => {
  const requestOptions = {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id')
    },
  };

  const url = new URL(`${config.apiGeneralUrl}/prescriptionDocumentRejectReasons`);

  return await fetch(url, requestOptions).then(handleResponse);
};

export const submitPrescriptionDocuments = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiClinicalUrl}/revaluation/submitPrescriptionDocuments`);

  return await fetch(url, requestOptions).then(handleResponse);
};

export const finalizePrescriptionDocumentsEvaluation = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiClinicalUrl}/revaluation/finalizePrescriptionDocumentsEvaluation`);

  return await fetch(url, requestOptions).then(handleResponse);
};

export const getPrescriptionsConfig = async () => {
  const requestOptions = {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id')
    },
  };

  const url = new URL(`${config.apiGeneralUrl}/prescriptionsConfig`);

  return await fetch(url, requestOptions).then(handleResponse);
};